namespace GeniuzPOS.ReportMasterData {
    export interface RecvData extends Serenity.ListRequest {
        Recv?: Report_1201_RecvRow[];
        Para?: Lookups.VwPsParaRow;
        URLpic?: string;
        BizName?: string;
        Shop?: string;
        DatetoDate?: string;
        Supdata?: string;
        fillterline1?: string;
        fillterline2?: string;
        fillterline3?: string;
        user?: string;
    }
}
